import React from "react";
import { useSelector } from "react-redux";
import { selectAccessorySizes } from "@ff-scene-plugins/photo-prints-redux/selectors/sizeSelectors";
import { PhotoPrintsPdpState } from "@ff-scene-plugins/photo-prints-redux/store";
import { convertAccessorySizesToUIFormat } from "../components";
import { AccessoryGrid } from "./AccessoryGrid";
import { AccessoryItem } from "./AccessoryItem";
import styles from "./AccessoriesOptionTab.module.scss";

export const AccessoriesOptionTab = () => {
	const accessorySizes = useSelector((state: PhotoPrintsPdpState) => selectAccessorySizes(state));
	const accessories = convertAccessorySizesToUIFormat(accessorySizes);

	return (
		<div className={styles.overflowXContainer}>
			<AccessoryGrid className={styles.accessoryGrid}>
				{accessories.map((accessory) => (
					<AccessoryItem
						key={accessory.id}
						accessory={accessory}
						className={styles.accessorySquare}
					/>
				))}
			</AccessoryGrid>
		</div>
	);
};